import { FilterMatchMode } from "primereact/api"

export class ConfiguracionFactor {
    model = {
        id: { value: null, table: false, export: false },
        nombre: {
            value: '', header: 'Nombre', required: 'Nombre es requerido', maxLength: 'Máximo 500 caracteres',
            minLength: 'Mínimo 4 caracteres', max: 500, min: 4, filterField: 'nombre', table: true, filter: true, sort: true,
            matchMode: FilterMatchMode.CONTAINS, headerStyle: { width: '70%' }
        },
        valor: {
            header: 'Valor', value: 0, required: false, export: true, table: true, filter: false, sort: false,
            min: 0, max: 5, headerStyle: { width: '15%' }
        },
        tipo_alerta_id: { value: null, header: 'Tipo Especial de Alerta', required: false, export: false, table: false },
        estado: {
            value: { nombre: 'SI', cat_id: true }, header: 'Activo', required: 'Estado es requerido', export: true, table: false
        }
    }
}